export const isRegularDepartmentEmployee = employee => (
  !employee?.category_id
);

export const buildOrderedCategoryGroups = (
  categories = [],
  employees = [],
  crossDepartmentEmployees = [],
) => categories.map(category => ({
    key: `category-${category.id}`,
    label: category.name,
    color: category.color || '#6B7280',
    entries: [
      ...employees
        .filter(employee => employee.category_id === category.id)
        .map(employee => ({ employee, isCrossDepartment: false })),
      ...crossDepartmentEmployees
        .filter(employee => employee.category_id === category.id)
        .map(employee => ({ employee, isCrossDepartment: true })),
    ],
  }));

export const buildEmployeeDisplaySections = (
  categories = [],
  employees = [],
  crossDepartmentEmployees = [],
) => [
  {
    key: 'regular',
    label: 'Regulär',
    entries: [
      ...employees
        .filter(isRegularDepartmentEmployee)
        .map(employee => ({ employee, isCrossDepartment: false })),
      ...crossDepartmentEmployees
        .filter(isRegularDepartmentEmployee)
        .map(employee => ({ employee, isCrossDepartment: true })),
    ],
  },
  ...buildOrderedCategoryGroups(categories, employees, crossDepartmentEmployees),
];

export const buildNonEmptyEmployeeDisplaySections = (
  categories = [],
  employees = [],
  crossDepartmentEmployees = [],
) => buildEmployeeDisplaySections(
  categories,
  employees,
  crossDepartmentEmployees,
).filter(section => section.entries.length > 0);
